import { useContext } from 'react';
import { useTheme } from '@material-ui/core';
import { LanguageContext } from '../../contexts/LanguageContext/languageContext';
import { floorPlanSection } from '../../components/MapRightDrawer/FloorPlanSection';
import { buildingsState, floorPlansState, selectedFloorPlanState } from '../../recoil/atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { FloorPlanType } from '../../contexts/AggregatesContext/types';

export const useFloorPlanSection = (
  selectedFp?: FloorPlanType | null,
  setSelectedFp?: (floorPlan: FloorPlanType | null) => void,
  onClick?: (floorPlan: FloorPlanType | null) => void,
) => {
  const { translate } = useContext(LanguageContext);
  const buildings = useRecoilValue(buildingsState);
  const floorPlans = useRecoilValue(floorPlansState);
  const [selectedFloorPlan, setSelectedFloorPlan] = useRecoilState(selectedFloorPlanState);
  const theme = useTheme();

  const section = floorPlanSection({
    buildings: buildings,
    floorPlans: floorPlans,
    selectedFloorPlan: setSelectedFp ? (selectedFp ? selectedFp : null ) : selectedFloorPlan,
    setSelectedFloorPlan: setSelectedFp ? setSelectedFp : setSelectedFloorPlan,
    onClick: onClick,
    theme,
    translateFunction: translate,
  });
  return { section };
};
